import request from "./request";

export async function getTypes() {
  const resp = await request()
    .get("/type")
    .then(resp => resp.data);
  return resp;
}

export async function addType(typeObj) {
  const resp = await request()
    .post("/type/add", typeObj)
    .then(resp => resp.data);
  return resp;
}

export async function deleteType(id) {
  const resp = await request()
    .get(`/type/delete/${id}`)
    .then(resp => resp.data);
  return resp;
}

export async function updateType(id, typeObj) {
  const resp = await request()
    .post(`/type/update/${id}`, typeObj)
    .then(resp => resp.data);
  return resp;
}

export async function getTypeById(id) {
  const resp = await request()
    .get(`/type/${id}`)
    .then(resp => resp.data);
  return resp;
}
